module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.34d7865f.png";